import { ICON_TABS, type IconTabs } from '@lighthouse/core'

export const DEFAULT_ALLOW_ICON_TYPES: IconTabs[] = [ICON_TABS.face, ICON_TABS.line, ICON_TABS.upload]

export const PURE_ALLOW_ICON_TYPES: IconTabs[] = [ICON_TABS.face, ICON_TABS.line]
